<div class="igntr-theme gami-toast-host">
  @for (t of toasts; track trackById($index, t)) {
    <div class="gami-toast" [class.leaving]="t.leaving" role="status">
      <span class="gami-toast__icon">
        <igntr-icon [name]="t.icon" [size]="20"></igntr-icon>
      </span>

      <div class="gami-toast__body">
        <div class="gami-toast__title">
          @switch (t.kind) {
            @case ('points') {
              {{ "pointsEarnedTitle" | transloco }}
            }
            @case ('achievement') {
              {{ "achievementUnlocked" | transloco }}
            }
            @case ('challenge') {
              {{ "challengeCompleted" | transloco }}
            }
          }
        </div>

        <div class="gami-toast__msg">
          @if (t.kind === "points") {
            @if (t.points) {
              <span class="gami-toast__pts"
                >+{{ t.points }} {{ "points" | transloco }}</span
              >
            }
            @if (t.reason) {
              <span class="gami-toast__reason"> · {{ t.reason }}</span>
            }
            @if (t.leveledUp) {
              <div class="gami-toast__level">
                {{ "leveledUpTo" | transloco }} {{ "level" | transloco }}
                {{ t.levelText }}
              </div>
            }
          } @else {
            <span class="gami-toast__name">{{ t.name }}</span>
            @if (t.points) {
              <span class="gami-toast__reason">
                (+{{ t.points }} {{ "points" | transloco }})</span
              >
            }
          }
        </div>
      </div>

      <button
        type="button"
        class="gami-toast__close"
        (click)="dismiss(t.id)"
        [attr.aria-label]="'close' | transloco"
      >
        <igntr-icon name="close" [size]="14"></igntr-icon>
      </button>
    </div>
  }
</div>
